import { EquipmentType } from '@cf-shared/data-model/equipment';
// type-only import, so this never becomes a runtime import cycle
import type { EquipmentTemplate } from './equipment-templates';
import { lbsToKg } from '@cf-shared/shared-util';

export const equipmentTemplatesUS: EquipmentTemplate[] = [
  {
    id: '$barbell',
    type: EquipmentType.Bar,
    nameKey: 'barbell',
    weight_unit: 'lb',
    bar_kg: lbsToKg(45),
    collar_kg: 0,
    plates: [
      { weight_kg: lbsToKg(55) },
      { weight_kg: lbsToKg(55) },
      { weight_kg: lbsToKg(55) },
      { weight_kg: lbsToKg(55) },
      { weight_kg: lbsToKg(45) },
      { weight_kg: lbsToKg(45) },
      { weight_kg: lbsToKg(35) },
      { weight_kg: lbsToKg(25) },
      { weight_kg: lbsToKg(10) },
      { weight_kg: lbsToKg(10) },
      { weight_kg: lbsToKg(5) },
      { weight_kg: lbsToKg(5) },
      { weight_kg: lbsToKg(2.5) },
    ],
  },
  {
    id: '$dumbbells',
    nameKey: 'dumbbells',
    type: EquipmentType.Fixed,
    weight_unit: 'lb',
    fixed: [
      { weight_kg: lbsToKg(2.5) },
      { weight_kg: lbsToKg(5) },
      { weight_kg: lbsToKg(7.5) },
      { weight_kg: lbsToKg(10) },
      { weight_kg: lbsToKg(12.5) },
      { weight_kg: lbsToKg(15) },
      { weight_kg: lbsToKg(17.5) },
      { weight_kg: lbsToKg(20) },
      { weight_kg: lbsToKg(25) },
      { weight_kg: lbsToKg(30) },
      { weight_kg: lbsToKg(35) },
      { weight_kg: lbsToKg(40) },
      { weight_kg: lbsToKg(45) },
      { weight_kg: lbsToKg(50) },
      { weight_kg: lbsToKg(55) },
      { weight_kg: lbsToKg(60) },
      { weight_kg: lbsToKg(65) },
      { weight_kg: lbsToKg(70) },
      { weight_kg: lbsToKg(75) },
      { weight_kg: lbsToKg(80) },
      { weight_kg: lbsToKg(85) },
      { weight_kg: lbsToKg(90) },
      { weight_kg: lbsToKg(95) },
      { weight_kg: lbsToKg(100) },
      { weight_kg: lbsToKg(105) },
      { weight_kg: lbsToKg(110) },
    ],
    plates: [],
  },
  {
    id: '$plates',
    type: EquipmentType.Plates,
    nameKey: 'plainPlates',
    weight_unit: 'lb',
    plates: [
      { weight_kg: lbsToKg(55) },
      { weight_kg: lbsToKg(55) },
      { weight_kg: lbsToKg(55) },
      { weight_kg: lbsToKg(55) },
      { weight_kg: lbsToKg(45) },
      { weight_kg: lbsToKg(45) },
      { weight_kg: lbsToKg(35) },
      { weight_kg: lbsToKg(25) },
      { weight_kg: lbsToKg(10) },
      { weight_kg: lbsToKg(10) },
      { weight_kg: lbsToKg(5) },
      { weight_kg: lbsToKg(5) },
      { weight_kg: lbsToKg(2.5) },
    ],
  },
  {
    id: '$kettlebells',
    nameKey: 'kettlebells',
    type: EquipmentType.Fixed,
    weight_unit: 'kg',
    fixed: [
      { weight_kg: lbsToKg(9) },
      { weight_kg: lbsToKg(13) },
      { weight_kg: lbsToKg(18) },
      { weight_kg: lbsToKg(26) },
      { weight_kg: lbsToKg(35) },
      { weight_kg: lbsToKg(40) },
      { weight_kg: lbsToKg(44) },
      { weight_kg: lbsToKg(53) },
      { weight_kg: lbsToKg(62) },
      { weight_kg: lbsToKg(70) },
      { weight_kg: lbsToKg(80) },
      { weight_kg: lbsToKg(88) },
      { weight_kg: lbsToKg(97) },
    ],
    plates: [],
  },
  {
    id: '$cable',
    type: EquipmentType.Stack,
    nameKey: 'cableMachine',
    weight_unit: 'lb',
    stack: [
      { totalWeight_kg: lbsToKg(5) },
      { totalWeight_kg: lbsToKg(10) },
      { totalWeight_kg: lbsToKg(15) },
      { totalWeight_kg: lbsToKg(20) },
      { totalWeight_kg: lbsToKg(25) },
      { totalWeight_kg: lbsToKg(30) },
      { totalWeight_kg: lbsToKg(35) },
      { totalWeight_kg: lbsToKg(40) },
      { totalWeight_kg: lbsToKg(45) },
      { totalWeight_kg: lbsToKg(50) },
      { totalWeight_kg: lbsToKg(55) },
      { totalWeight_kg: lbsToKg(60) },
      { totalWeight_kg: lbsToKg(65) },
      { totalWeight_kg: lbsToKg(70) },
      { totalWeight_kg: lbsToKg(75) },
      { totalWeight_kg: lbsToKg(80) },
      { totalWeight_kg: lbsToKg(85) },
      { totalWeight_kg: lbsToKg(90) },
      { totalWeight_kg: lbsToKg(95) },
      { totalWeight_kg: lbsToKg(100) },
      { totalWeight_kg: lbsToKg(105) },
      { totalWeight_kg: lbsToKg(110) },
      { totalWeight_kg: lbsToKg(115) },
      { totalWeight_kg: lbsToKg(120) },
      { totalWeight_kg: lbsToKg(125) },
      { totalWeight_kg: lbsToKg(130) },
      { totalWeight_kg: lbsToKg(135) },
      { totalWeight_kg: lbsToKg(140) },
      { totalWeight_kg: lbsToKg(145) },
      { totalWeight_kg: lbsToKg(150) },
      { totalWeight_kg: lbsToKg(155) },
      { totalWeight_kg: lbsToKg(160) },
      { totalWeight_kg: lbsToKg(165) },
      { totalWeight_kg: lbsToKg(170) },
      { totalWeight_kg: lbsToKg(175) },
      { totalWeight_kg: lbsToKg(180) },
      { totalWeight_kg: lbsToKg(185) },
      { totalWeight_kg: lbsToKg(190) },
      { totalWeight_kg: lbsToKg(195) },
      { totalWeight_kg: lbsToKg(200) },
      { totalWeight_kg: lbsToKg(205) },
      { totalWeight_kg: lbsToKg(210) },
      { totalWeight_kg: lbsToKg(215) },
      { totalWeight_kg: lbsToKg(220) },
      { totalWeight_kg: lbsToKg(225) },
      { totalWeight_kg: lbsToKg(230) },
      { totalWeight_kg: lbsToKg(235) },
      { totalWeight_kg: lbsToKg(240) },
      { totalWeight_kg: lbsToKg(245) },
      { totalWeight_kg: lbsToKg(250) },
      { totalWeight_kg: lbsToKg(255) },
      { totalWeight_kg: lbsToKg(260) },
      { totalWeight_kg: lbsToKg(265) },
      { totalWeight_kg: lbsToKg(270) },
      { totalWeight_kg: lbsToKg(275) },
      { totalWeight_kg: lbsToKg(280) },
      { totalWeight_kg: lbsToKg(285) },
      { totalWeight_kg: lbsToKg(290) },
      { totalWeight_kg: lbsToKg(295) },
      { totalWeight_kg: lbsToKg(300) },
      { totalWeight_kg: lbsToKg(305) },
      { totalWeight_kg: lbsToKg(310) },
      { totalWeight_kg: lbsToKg(315) },
      { totalWeight_kg: lbsToKg(320) },
      { totalWeight_kg: lbsToKg(325) },
      { totalWeight_kg: lbsToKg(330) },
      { totalWeight_kg: lbsToKg(335) },
      { totalWeight_kg: lbsToKg(340) },
      { totalWeight_kg: lbsToKg(345) },
      { totalWeight_kg: lbsToKg(350) },
      { totalWeight_kg: lbsToKg(355) },
      { totalWeight_kg: lbsToKg(360) },
      { totalWeight_kg: lbsToKg(365) },
      { totalWeight_kg: lbsToKg(370) },
      { totalWeight_kg: lbsToKg(375) },
      { totalWeight_kg: lbsToKg(380) },
      { totalWeight_kg: lbsToKg(385) },
      { totalWeight_kg: lbsToKg(390) },
      { totalWeight_kg: lbsToKg(395) },
      { totalWeight_kg: lbsToKg(400) },
      { totalWeight_kg: lbsToKg(405) },
      { totalWeight_kg: lbsToKg(410) },
      { totalWeight_kg: lbsToKg(415) },
      { totalWeight_kg: lbsToKg(420) },
      { totalWeight_kg: lbsToKg(425) },
      { totalWeight_kg: lbsToKg(430) },
      { totalWeight_kg: lbsToKg(435) },
      { totalWeight_kg: lbsToKg(440) },
    ],
    plates: [],
  },
  {
    id: '$custom',
    type: EquipmentType.Manual,
    nameKey: 'customIncrements',
    weight_unit: 'lb',
    weight_min_kg: 0,
    weight_inc_kg: lbsToKg(5),
  },
];
